import CandidateReqDocuments from './CandidateReqDocuments.component';

export default CandidateReqDocuments;